import React, { useState } from 'react';
import { Modal } from '@carbon/react';
import { StreamsModalIndex } from './StreamsIndex';

const SelectStreamModel = ({ onSelectStream = () => {}, hideModal, title = "Stream auswählen"}) => {

  const [selections, setSelections] = useState([]);

  const onItemSelected = (items) => {
    setSelections(items);
  }
  const onSubmitRequest = () => {
    onSelectStream(selections);
    hideModal();
  }

  return (
    <Modal
      open={true}
      danger={false}
      size="lg"
      primaryButtonText={'Auswählen'}
      secondaryButtonText={'Abrechen'}
      modalHeading={title}
      onRequestClose={hideModal}
      onRequestSubmit={onSubmitRequest}
      className="prevent-scroll-content">
      <StreamsModalIndex modal onSelectionChange={onItemSelected} />
    </Modal>
  )
}

export default SelectStreamModel;
